jQuery( '.staggered-section .staggered-slider' ).slick( {
    speed: 300,
    cssEase: 'ease',
    infinite: false,
    arrows: false,
    dots: true,
} );

jQuery( '.staggered-section .images' ).slick( {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2
            }
        },
    ]
} );

jQuery( '.staggered-section .play-video' ).on( 'click', function() {
    var video = jQuery( this ).siblings( 'video' );
    jQuery( video ).get( 0 ).play();

    jQuery( video ).attr( 'controls', true );

    jQuery( this ).fadeOut();
} );